import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { getShortVideoRecom } from '../../../../services/api';
import { formatImage } from '@ifeng-fe/public_method';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import { transformArr } from '../../../../utils/utils';
import { cookie } from '@ifeng-fe/ui_base';
import { userkeyUtil } from 'ThreeTerminal_utils';
import styles from './index.css';

class RelateVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        recomVideo: [],
    };

    getAuthorName = (item = {}) => {
        return (
            item.source ||
            item.sourceName ||
            item.columnName ||
            item.weMediaName ||
            item.authorName ||
            item.mediaName ||
            ''
        );
    };

    getAuthorLogo = (item = {}) => {
        return item?.subscribe?.logo || '';
    };

    async componentDidMount() {
        const { content } = this.props;
        let userkey = cookie.get('userkey');

        if (!userkey) {
            userkey = userkeyUtil.get(15);
        }
        let result = await getShortVideoRecom(content.base62Id, userkey);

        if (result && result.length > 0) {
            result = result.map((item) => {
                const goUrl = item?.link?.weburl;

                return {
                    title: item.title,
                    thumbnail: item.thumbnail && formatImage(item.thumbnail.replace(/\.webp|_webp/g, ''), 748, 1332),
                    source: this.getAuthorName(item),
                    sourceLogo: this.getAuthorLogo(item),
                    url: goUrl || '',
                };
            });
            result = transformArr(result.slice(0, 6), 2);

            this.setState({
                recomVideo: result,
            });
        }
    }

    render() {
        const { recomVideo } = this.state;

        return (
            <div className={styles.relateVideo}>
                {recomVideo.map((itemOut, indexOut) => {
                    return (
                        <div key={indexOut} className={styles.relateVideoItem}>
                            {itemOut.map((itemIn, indexIn) => {
                                return (
                                    <div key={indexIn} className={styles.relateVideoBox}>
                                        <a className={styles.relateVideoLink} href={itemIn.url}>
                                            <div className={styles.relateVideoPicBox}>
                                                {itemIn.thumbnail && (
                                                    <LazyImg className={styles.relateVideoPic} src={itemIn.thumbnail} />
                                                )}
                                                {itemIn.thumbnail && <span className={styles.playIcon} />}
                                            </div>
                                            <div className={styles.relateVideoInfo}>
                                                <div className={styles.relateVideoText}>{itemIn.title}</div>
                                                {itemIn.source && (
                                                    <div className={styles.relateVideoFooter}>
                                                        <div className={styles.relateVideoAuthor}>
                                                            {itemIn.sourceLogo ? (
                                                                <img
                                                                    className={styles.relateVideoAvatar}
                                                                    src={itemIn.sourceLogo}
                                                                />
                                                            ) : (
                                                                null
                                                            )}
                                                            <div className={styles.relateVideoSource}>{itemIn.source}</div>
                                                        </div>
                                                        <span className={styles.relateVideoLike} />
                                                    </div>
                                                )}
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}
                            {itemOut.length === 1 && <div className={styles.relateVideoPlaceholder} />}
                        </div>
                    );
                })}
                {recomVideo.length > 0 && <div className={styles.relateVideoEnd} />}
            </div>
        );
    }
}

export default errorBoundary(RelateVideo);
